/**
 * ttLayout — Pure structure blueprints for Twisted Treeline 3v3 (Season 2).
 * Positions use gameplay scale (~1/10 of 24000×18000 world units).
 */

export const TT_STRUCTURE_TIERS = {
  outer: { hp: 2550, ad: 152, armor: 40, mr: 40, attackRange: 750, radius: 35 },
  inhibitorTurret: { hp: 2550, ad: 190, armor: 40, mr: 40, attackRange: 750, radius: 35 },
  inhibitor: { hp: 4000, ad: 0, armor: 20, mr: 0, attackRange: 0, radius: 40, respawnTimer: 300 },
  nexusTurret: { hp: 2550, ad: 190, armor: 40, mr: 40, attackRange: 750, radius: 35 },
  nexus: { hp: 5500, ad: 0, armor: 15, mr: 0, attackRange: 0, radius: 55 }
};

function turretBlueprint(id, team, tier, x, y, requires = null) {
  const stats = TT_STRUCTURE_TIERS[tier];
  return {
    id,
    team,
    type: tier === 'inhibitor' ? 'inhibitor' : (tier === 'nexus' ? 'nexus' : 'turret'),
    tier,
    x,
    y,
    requires,
    maxHp: stats.hp,
    ad: stats.ad,
    armor: stats.armor,
    mr: stats.mr,
    attackRange: stats.attackRange,
    radius: stats.radius,
    respawnTimer: stats.respawnTimer
  };
}

function teamStructures(team, side) {
  const s = side;
  return [
    turretBlueprint(`${team}-top-outer`, team, 'outer', s.topOuter.x, s.topOuter.y),
    turretBlueprint(`${team}-top-inhib-turret`, team, 'inhibitorTurret', s.topInhibTurret.x, s.topInhibTurret.y, `${team}-top-outer`),
    turretBlueprint(`${team}-top-inhib`, team, 'inhibitor', s.topInhib.x, s.topInhib.y, `${team}-top-inhib-turret`),
    turretBlueprint(`${team}-bot-outer`, team, 'outer', s.botOuter.x, s.botOuter.y),
    turretBlueprint(`${team}-bot-inhib-turret`, team, 'inhibitorTurret', s.botInhibTurret.x, s.botInhibTurret.y, `${team}-bot-outer`),
    turretBlueprint(`${team}-bot-inhib`, team, 'inhibitor', s.botInhib.x, s.botInhib.y, `${team}-bot-inhib-turret`),
    turretBlueprint(`${team}-nexus-turret`, team, 'nexusTurret', s.nexusTurret.x, s.nexusTurret.y, `${team}-top-inhib`),
    turretBlueprint(`${team}-nexus`, team, 'nexus', s.nexus.x, s.nexus.y, `${team}-nexus-turret`)
  ];
}

const BLUE_SIDE = {
  topOuter: { x: 500, y: 400 },
  topInhibTurret: { x: 400, y: 400 },
  topInhib: { x: 350, y: 450 },
  botOuter: { x: 500, y: 1400 },
  botInhibTurret: { x: 400, y: 1400 },
  botInhib: { x: 350, y: 1350 },
  nexusTurret: { x: 350, y: 900 },
  nexus: { x: 300, y: 900 }
};

const RED_SIDE = {
  topOuter: { x: 1700, y: 400 },
  topInhibTurret: { x: 1800, y: 400 },
  topInhib: { x: 1850, y: 450 },
  botOuter: { x: 1700, y: 1400 },
  botInhibTurret: { x: 1800, y: 1400 },
  botInhib: { x: 1850, y: 1350 },
  nexusTurret: { x: 1850, y: 900 },
  nexus: { x: 1900, y: 900 }
};

export function getTwistedTreelineStructures() {
  return [
    ...teamStructures('blue', BLUE_SIDE),
    ...teamStructures('red', RED_SIDE)
  ];
}
